import React from 'react';

import { ScrollView } from '@fhs-legacy/universal-components';
import Modal, { ModalContent } from 'components/modal';

import DiagnosticModalContents from './diagnostic-modal-contents';
import { IInternalStoreDiagnosticsModalProps } from './types';

export const InternalStoreDiagnosticModal: React.FC<
  React.PropsWithChildren<IInternalStoreDiagnosticsModalProps>
> = ({ onModalDismiss, storeDiagnosticData }) => (
  <Modal
    onDismiss={onModalDismiss}
    accessibilityLabel="Store Diagnostics"
    contentAccessibilityRole="none"
    mParticleEventData={{
      modalAppearanceEventMessage: 'Store Diagnostics',
    }}
  >
    <ModalContent flex={1}>
      {/* accessible={false} so the scroll surface is not one opaque group; children (headings, text) are read individually */}
      <ScrollView accessible={false}>
        <DiagnosticModalContents storeDiagnosticData={storeDiagnosticData} />
      </ScrollView>
    </ModalContent>
  </Modal>
);
